import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import toast from "react-hot-toast";
import { consoleLog } from "helpers";

export const getConfigAPI = async (
  { pageIndex, skip },
  isLoading,
  accessJWT
) => {
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      skip: pageIndex + 1,
      limit: skip,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/config/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterConfigsAPI = async (
  { searchQuery, pageIndex, limit, skip },
  payload,
  setIsLoading,
  accessJWT
) => {
  try {
    setIsLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    consoleLog([payload, "payloadpayloadpayload"]);

    const body = {
      ...payload,
      skip: pageIndex + 1,
      limit: limit,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/config/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (setIsLoading) setIsLoading(false);
      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    throw new Error("Error fetching data");
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  } finally {
    setIsLoading(false);
  }
};

export const createOrUpdateConfigAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/config`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(API_URL, encryptData({ ...args }), config)
      : await axios.post(API_URL, encryptData({ ...args }), config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    if (
      parsedResponseData?.statusCode === 400 &&
      parsedResponseData?.message === "Key already exists"
    ) {
      toast.error(parsedResponseData?.message);
      return parsedResponseData;
    }
    throw Error;
  } catch (error) {
    isLoading(false);
    // if(error?.response?.status === 400) {
    //   console.error("Error creating/updating destination:", error?.response?.data?.message);
    //   return null;
    // }
    console.error("Error creating/updating config:", error?.message);
    return null;
  }
};

export const deleteConfigAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/config?id=${args.id}`;
  try {
    const config = getHeaderConfig(null, accessJWT);
    if (isLoading) isLoading(true);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting config:", error);
    return null;
  }
};

export const getConfigCategoryAPI = async (accessJWT, isLoading) => {
  const API_URL = `${ENDPOINT}/app/v1/configCategory`;

  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const response = await axios.get(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      return parsedResponseData?.data;
    }

    throw new Error(
      parsedResponseData?.message || "Failed to fetch config categories"
    );
  } catch (error) {
    console.error("Error fetching config categories:", error);
    return null;
  } finally {
    if (isLoading) isLoading(false);
  }
};
